import { receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { camelizeKeys } from 'receivable-invoices-js/react/utils/camelize-keys';
import { fetchInvoices } from './fetch-invoices';

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  receivableInvoicesApiNamespace: '/api/v5',
}));

vi.mock('@repo/design-system-kit', () => ({
  useToast: vi.fn(() => ({
    showToast: vi.fn(),
  })),
}));

describe('unit | API | queries | fetch-invoices', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const clientId = 'client-123';
  const URL = `${receivableInvoicesApiNamespace}/receivable_invoices/invoices/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe(fetchInvoices, () => {
    it('fetches invoices successfully', async () => {
      const apiResponse = {
        data: [
          {
            id: 'invoice-123',
            type: 'receivable_invoices',
            attributes: {
              locale: 'fr',
              number: 'F-2025-002',
              status: 'unpaid',
              reference: '123456789',
              terms_and_conditions: '',
              subtotal: {
                value: '270.00',
                currency: 'EUR',
              },
              vat_amount: {
                value: '54.00',
                currency: 'EUR',
              },
              amount_due: {
                value: '324.00',
                currency: 'EUR',
              },
              issue_date: '2025-08-24',
              due_date: '2025-09-08',
              performance_start_date: '',
              performance_end_date: '',
              overdue: false,
              pdf_url: 'https://pdf.url',
              contact_email: 'jane@doe.com',
              payment_methods: [
                {
                  type: 'transfer',
                  beneficiary_name: 'Some Organization',
                  bic: 'QNTOFRP1XXX',
                  iban: 'FR7616958000014265796572584',
                },
              ],
              sections: [
                {
                  id: '0198dcf3-3279-79e9-af18-49334c26cc3f',
                  title: 'Section 1',
                  description: 'Blah blah',
                  items: [
                    {
                      title: 'Web services',
                      description: '',
                      quantity: '1',
                      unit_price: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      unit: 'hour',
                      vat_rate: '0.2',
                      total_vat: {
                        value: '20.00',
                        currency: 'EUR',
                      },
                      total_amount: {
                        value: '120.00',
                        currency: 'EUR',
                      },
                      subtotal: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                    },
                    {
                      title: 'Second item',
                      description: '',
                      quantity: '1',
                      unit_price: {
                        value: '20.00',
                        currency: 'EUR',
                      },
                      unit: 'hour',
                      vat_rate: '0.2',
                      total_vat: {
                        value: '4.00',
                        currency: 'EUR',
                      },
                      total_amount: {
                        value: '24.00',
                        currency: 'EUR',
                      },
                      subtotal: {
                        value: '20.00',
                        currency: 'EUR',
                      },
                    },
                    {
                      title: 'Third item',
                      description: '',
                      quantity: '1',
                      unit_price: {
                        value: '50.00',
                        currency: 'EUR',
                      },
                      unit: 'hour',
                      vat_rate: '0.2',
                      total_vat: {
                        value: '10.00',
                        currency: 'EUR',
                      },
                      total_amount: {
                        value: '60.00',
                        currency: 'EUR',
                      },
                      subtotal: {
                        value: '50.00',
                        currency: 'EUR',
                      },
                    },
                  ],
                },
                {
                  id: '0198dcf3-3279-7a03-8201-90cc291ce0ee',
                  title: 'Section 2',
                  description: 'more blah',
                  items: [
                    {
                      title: 'Web services',
                      description: '',
                      quantity: '1',
                      unit_price: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      unit: 'hour',
                      vat_rate: '0.2',
                      total_vat: {
                        value: '20.00',
                        currency: 'EUR',
                      },
                      total_amount: {
                        value: '120.00',
                        currency: 'EUR',
                      },
                      subtotal: {
                        value: '100.00',
                        currency: 'EUR',
                      },
                      product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                    },
                  ],
                },
              ],
              organization: {
                id: '3fabc81a-5124-4b33-9f01-dec4d364befa',
                slug: 'french-team-business-organization-2241',
                legal_name: 'French Team Business Organization',
                legal_form: 'SAS',
                legal_number: '81948962600039',
                legal_country: 'FR',
                vat_number: '',
                district_court: '',
                company_leadership: '',
                commercial_register_number: '',
                legal_capital_share: null,
                vat_payment_condition: '',
                transaction_type: '',
                tax_number: '',
                address_line1: '18 Rue de Navarin',
                address_line2: 'chez Wework',
                address_zipcode: '75009',
                address_city: 'Paris',
                address_country: 'FR',
              },
              customer_snapshot: {
                kind: 'company',
                name: 'BMW FINANCE',
                first_name: '',
                last_name: '',
                tin_number: '343606448',
                vat_number: 'FR65343606448',
                address_line1: '5 RUE DES HERONS',
                address_line2: '',
                address_zipcode: '78180',
                address_city: 'MONTIGNY-LE-BRETONNEUX',
                address_country: 'FR',
              },
              stamp_duty_amount: null,
              logo_url: '',
              is_pdf_generated: true,
              header: '',
              footer: '',
              currency: 'EUR',
              direct_debit_enabled: false,
              is_einvoice: false,
              payment_link: {},
            },
          },
        ],
      };

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchInvoices({ clientId }, {});

      expect(mockQontoClient).toHaveBeenCalledWith(URL, {
        params: { client_id: clientId, page: { number: 1, size: 100 } },
      });

      expect(result).toStrictEqual(
        camelizeKeys([
          {
            locale: 'fr',
            number: 'F-2025-002',
            status: 'unpaid',
            reference: '123456789',
            terms_and_conditions: '',
            subtotal: {
              value: '270.00',
              currency: 'EUR',
            },
            vat_amount: {
              value: '54.00',
              currency: 'EUR',
            },
            amount_due: {
              value: '324.00',
              currency: 'EUR',
            },
            issue_date: '2025-08-24',
            due_date: '2025-09-08',
            performance_start_date: '',
            performance_end_date: '',
            overdue: false,
            pdf_url: 'https://pdf.url',
            contact_email: 'jane@doe.com',
            payment_methods: [
              {
                type: 'transfer',
                beneficiary_name: 'Some Organization',
                bic: 'QNTOFRP1XXX',
                iban: 'FR7616958000014265796572584',
              },
            ],
            sections: [
              {
                id: '0198dcf3-3279-79e9-af18-49334c26cc3f',
                title: 'Section 1',
                description: 'Blah blah',
                items: [
                  {
                    title: 'Web services',
                    description: '',
                    quantity: '1',
                    unit_price: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    unit: 'hour',
                    vat_rate: '0.2',
                    total_vat: {
                      value: '20.00',
                      currency: 'EUR',
                    },
                    total_amount: {
                      value: '120.00',
                      currency: 'EUR',
                    },
                    subtotal: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                  },
                  {
                    title: 'Second item',
                    description: '',
                    quantity: '1',
                    unit_price: {
                      value: '20.00',
                      currency: 'EUR',
                    },
                    unit: 'hour',
                    vat_rate: '0.2',
                    total_vat: {
                      value: '4.00',
                      currency: 'EUR',
                    },
                    total_amount: {
                      value: '24.00',
                      currency: 'EUR',
                    },
                    subtotal: {
                      value: '20.00',
                      currency: 'EUR',
                    },
                  },
                  {
                    title: 'Third item',
                    description: '',
                    quantity: '1',
                    unit_price: {
                      value: '50.00',
                      currency: 'EUR',
                    },
                    unit: 'hour',
                    vat_rate: '0.2',
                    total_vat: {
                      value: '10.00',
                      currency: 'EUR',
                    },
                    total_amount: {
                      value: '60.00',
                      currency: 'EUR',
                    },
                    subtotal: {
                      value: '50.00',
                      currency: 'EUR',
                    },
                  },
                ],
              },
              {
                id: '0198dcf3-3279-7a03-8201-90cc291ce0ee',
                title: 'Section 2',
                description: 'more blah',
                items: [
                  {
                    title: 'Web services',
                    description: '',
                    quantity: '1',
                    unit_price: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    unit: 'hour',
                    vat_rate: '0.2',
                    total_vat: {
                      value: '20.00',
                      currency: 'EUR',
                    },
                    total_amount: {
                      value: '120.00',
                      currency: 'EUR',
                    },
                    subtotal: {
                      value: '100.00',
                      currency: 'EUR',
                    },
                    product_id: '0198dc4b-9fc1-7f33-bfcc-83b2b06b4eee',
                  },
                ],
              },
            ],
            organization: {
              id: '3fabc81a-5124-4b33-9f01-dec4d364befa',
              slug: 'french-team-business-organization-2241',
              legal_name: 'French Team Business Organization',
              legal_form: 'SAS',
              legal_number: '81948962600039',
              legal_country: 'FR',
              vat_number: '',
              district_court: '',
              company_leadership: '',
              commercial_register_number: '',
              legal_capital_share: null,
              vat_payment_condition: '',
              transaction_type: '',
              tax_number: '',
              address_line1: '18 Rue de Navarin',
              address_line2: 'chez Wework',
              address_zipcode: '75009',
              address_city: 'Paris',
              address_country: 'FR',
            },
            customer_snapshot: {
              kind: 'company',
              name: 'BMW FINANCE',
              first_name: '',
              last_name: '',
              tin_number: '343606448',
              vat_number: 'FR65343606448',
              address_line1: '5 RUE DES HERONS',
              address_line2: '',
              address_zipcode: '78180',
              address_city: 'MONTIGNY-LE-BRETONNEUX',
              address_country: 'FR',
            },
            stamp_duty_amount: null,
            logo_url: '',
            is_pdf_generated: true,
            header: '',
            footer: '',
            currency: 'EUR',
            direct_debit_enabled: false,
            is_einvoice: false,
            payment_link: {},
            id: 'invoice-123',
          },
        ])
      );
    });

    it('handles API errors with custom error handler', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      const onError = vi.fn<(err: unknown) => void>();
      await fetchInvoices({ clientId }, { onError });

      expect(onError).toHaveBeenCalledWith(error);
    });

    it('throws error when no error handler is provided', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      await expect(fetchInvoices({ clientId }, {})).rejects.toThrow('API Error');
    });

    it('handles empty response data', async () => {
      const mockResponse = { data: [] };
      mockQontoClient.mockResolvedValue(mockResponse);

      const result = await fetchInvoices({ clientId }, {});

      expect(result).toStrictEqual([]);
    });
  });
});
